"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar, CircleAlert } from "lucide-react";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="224434" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden border-border/50 shadow-sm">
                        <div className="aspect-[16/10] bg-muted/30 animate-pulse" />
                        <CardContent className="p-6">
                            <div className="h-6 w-3/4 bg-muted/30 animate-pulse rounded mb-4" />
                            <div className="h-4 w-full bg-muted/30 animate-pulse rounded mb-2" />
                            <div className="h-4 w-2/3 bg-muted/30 animate-pulse rounded" />
                        </CardContent>
                    </Card>)}
            </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center p-12 text-center border border-border/50 rounded-xl bg-muted/10">
                <CircleAlert className="size-10 text-destructive mb-4" />
                <p className="text-muted-foreground mb-4">Error al cargar las publicaciones técnicas.</p>
                <Button variant="outline" onClick={refetch}>Reintentar</Button>
            </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center p-12 border border-border/50 rounded-xl bg-muted/10">
                <p className="text-muted-foreground">No hay artículos disponibles en este momento.</p>
            </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, i) => {
      const imageUrl = post.featuredImage || `/img/consulting_insight_${i % 3 + 1}.png`;
      const category = post.categories && post.categories.length > 0 ? post.categories[0].name : 'ANÁLISIS';
      return <Card key={post.id} data-index={i} className="group overflow-hidden border-border/50 shadow-none hover:border-primary/50 transition-all duration-300 flex flex-col bg-card">
                        <div className="relative aspect-[16/10] overflow-hidden">
                            <img src={imageUrl} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                            <div className="absolute top-4 right-4 z-10">
                                <Badge variant="secondary" className="bg-background/80 backdrop-blur-sm text-foreground border-none font-mono px-3 py-1 text-[10px] tracking-widest uppercase">
                                    {category}
                                </Badge>
                            </div>
                            {}
                            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
                        </div>

                        <CardContent className="p-6 flex flex-col flex-grow relative z-20 bg-card">
                            {post.date && <div className="flex items-center gap-2 text-[10px] font-mono text-muted-foreground mb-3 uppercase tracking-wider">
                                    <SafeHydrate><Calendar className="size-3" /></SafeHydrate>
                                    <span>{new Date(post.date).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })}</span>
                                </div>}

                            <h3 className="text-xl font-bold font-default text-foreground mb-3 line-clamp-2 group-hover:text-primary transition-colors">
                                {post.title}
                            </h3>

                            <div className="text-muted-foreground text-sm font-default line-clamp-2 mb-6 flex-grow">
                                {post.excerpt ? <div dangerouslySetInnerHTML={{
              __html: post.excerpt
            }} /> : <p>Análisis técnico detallado sobre implementación de infraestructura y optimización de operaciones para PyMEs.</p>}
                            </div>

                            <div className="mt-auto pt-4 border-t border-border/30">
                                <Link to={post.link || "#"} className="inline-flex items-center gap-2 text-xs font-mono font-semibold text-primary hover:text-primary/80 transition-colors group/link">
                                    <span>VER ARTÍCULO</span>
                                    <ArrowLeft className="size-4 rotate-180 transition-transform duration-300 group-hover/link:translate-x-1" />
                                </Link>
                            </div>
                        </CardContent>
                    </Card>;
    })}
        </div>;
}
export default function LatestNewsAndActivities() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}